<lib-prod-form [fields]="fields" (onSubmitEvent)="submit($event)" [formValidators]="formValidators" [data]="data" [showCancelButton]="!data['isRequired']"></lib-prod-form>
